import React from "react";
import MoreProjectCards from "../MoreProjectCards";

function More() {
	return <MoreProjectCards />;
}

export default More;
